export default "__VITE_ASSET__0b1eec5f__"